import { render, staticRenderFns } from "./question_answer.vue?vue&type=template&id=71f9ee76&scoped=true&"
import script from "./question_answer.vue?vue&type=script&lang=js&"
export * from "./question_answer.vue?vue&type=script&lang=js&"
import style0 from "./question_answer.vue?vue&type=style&index=0&id=71f9ee76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9ee76",
  null
  
)

export default component.exports